module.exports = __webpack_public_path__ + "static/media/project-img8.3e69bcde.jpg";